import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-info",
  "use": "status-info-usage",
  "viewBox": "0 0 76.03 76.03",
  "content": "<symbol viewBox=\"0 0 76.03 76.03\" id=\"status-info\"><title>资源 3</title><g id=\"status-info_图层_2\" data-name=\"图层 2\"><g id=\"status-info_图层_1-2\" data-name=\"图层 1\"><path d=\"M38,0A38,38,0,1,0,76,38,38,38,0,0,0,38,0Zm2.6,53.22a2.55,2.55,0,0,1-5.1,0V33.94a2.55,2.55,0,0,1,5.1,0ZM38,26.83a3,3,0,1,1,0-6.06,3,3,0,1,1,0,6.06Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/status-info.svg
// module id = J5Nu
// module chunks = 264